import s from './Helitage.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faStickyNote } from '@fortawesome/free-solid-svg-icons';
import SubHeader from '../../components/SubHeader/SubHeader';
import { Aside } from '../../components/Aside/Aside';
import { Helmet } from "react-helmet";

const blogs = [

  {
    id: 5,
    title: 'オーストラリア、キュランダの世界自然遺産である熱帯雨林について知ろう',
    date: '2019年10月3日',
    category: '世界遺産の観光スポット',
    comment: '',
    img: 'https://dev.mightyaussie.com/wp-content/uploads/2019/10/kuranda_helitage_main-1-960x530.png',
    body: 'オーストラリアの世界遺産を含めたおすすめ観光スポット情報を探していませんか？定番どころから少し穴場的なスポットまでオーストラリアの観光スポット26選をご覧ください。オーストラリアへ旅行したくなりますよ！旅行の際はぜひジェイさんツアーまでご相談ください。',
    link: '/blog/helitage/kuranda_helitage',
    magazine: false,
    sale: false,
    world: true,
    info: false,
  },
  {
    id: 6,
    title: 'オーストラリアの世界遺産（観光名所）に登録された数・場所20選',
    date: '2019年10月2日',
    category: '世界遺産の観光スポット',
    comment: '',
    img: 'https://dev.mightyaussie.com/wp-content/uploads/2019/10/helitage20_main-1-960x530.png',
    body: 'オーストラリアの世界遺産（観光名所）は全部で20箇所あります。オーストラリアの広い国土は日本の約20倍もあります！観光名所をどこにしようか、と決めかねてしまうのではないでしょうか？マップで全体のいちを把握しながら、どのような世界遺産がどこにあるのかを把握していきましょう。',
    link: '/blog/helitage/helitage20',
    magazine: false,
    sale: false,
    world: true,
    info: false,
  },
  {
    id: 7,
    title: 'オーストラリアの世界遺産を含めたおすすめ観光スポット26選',
    date: '2019年9月30日',
    category: '世界遺産の観光スポット',
    comment: '',
    img: 'https://dev.mightyaussie.com/wp-content/uploads/2019/09/australia_helitage_spot26_main-960x530.png',
    body: 'オーストラリアの世界遺産を含めたおすすめ観光スポット情報を探していませんか？定番どころから少し穴場的なスポットまでオーストラリアの観光スポット26選をご覧ください。オーストラリアへ旅行したくなりますよ！旅行の際はぜひジェイさんツアーまでご相談ください。',
    link: '/blog/helitage/australia_helitage_spot26',
    magazine: false,
    sale: false,
    world: true,
    info: false,
  },
];
const breadcrumbs = [
  { label: 'ホーム ', link: '/' },
  { label: 'ジェイさんブログ', link: '/blog' },
  { label: '世界遺産の観光スポット'},
];


const Helitage = () => {
  return (
    <>
          <Helmet>
        <title>世界遺産の観光スポット – ケアンズの旅行やツアーを最安値で予約【ジェイさんツアー】</title>
        <meta property="og:title" content="世界遺産の観光スポット – ケアンズの旅行やツアーを最安値で予約【ジェイさんツアー】" />
        <meta property="og:url" content={`${process.env.REACT_APP_URL}/category/blog/helitage`} />
        <meta name="description" content="自社ツアーやオプショナルツアーも予約できます！" />
        <meta property="og:description" content="自社ツアーやオプショナルツアーも予約できます！" />
        <meta property="og:type" content="article" />
      </Helmet>
    <div className={s.root}>
    <SubHeader
      title="カテゴリー: 世界遺産の観光スポット"
      breadcrumbs={breadcrumbs}
    />
      <div className={s.flex}>
      <div className={s.blogContainer}>
    {blogs.map((blog) => (
      <a
        key={blog.id}
        href={blog.link}
        className={s.cardLinkWrapper}
        aria-label={blog.title}
      >
        <div className={s.card}>
          <div className={s.cardContent}>
            <h3 className={s.cardTitle}>{blog.title}</h3>
              <div className={s.cardMeta}>
                <span className={s.cardMetaItem}>
                <i className="fa fa-calendar"></i>{blog.date}
                </span>
                <span className={s.cardMetaItem}>
                <i className="fa fa-user"></i>ジェイさんツアー
                </span>
                {blog.magazine && (
                  <span className={s.cardMetaItem}>
                  <i className="fa fa-pencil"></i>ジェイさんマガジン
                  </span>
                )}
                {blog.sale && (
                  <span className={s.cardMetaItem}>
                  <i className="fa fa-pencil"></i>ツアーをお得に探す
                  </span>
                )}
                {blog.world && (
                  <span className={s.cardMetaItem}>
                  <i className="fa fa-pencil"></i>世界遺産の観光スポット
                  </span>
                )}
                {blog.info && (
                  <span className={s.cardMetaItem}>
                  <i className="fa fa-pencil"></i>ケアンズで快適に過ごすお得情報
                  </span>
                )}
              </div>
            <img src={blog.img} alt={blog.title} className={s.cardImage} />
            <p className={s.cardBody}>{blog.body.slice(0, 100)}...</p>
            <div className={s.center}><a className={s.button} href={blog.link}>続きを見る<i class="atbtn__icon atbtn__icon--right fa fa-long-arrow-right"></i></a></div>
          </div>
        </div>
      </a>
    ))}
  </div>
     <Aside/>
      </div>
    </div>
    </>
  );
}

export default Helitage;
